import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Loader from 'components/Loader'
import Section from 'components/Section'
import Item from 'components/RevenueCenters/Item'

import RevenueCentersDetailsPage from 'pages/RevenueCentersDetails'
import {
  getGroupedMenusForCurrentRevenueCenter,
  getIsLoadingAvailability,
  getIsRevenueCentersLoading,
} from 'store/RevenueCenters/selector'
import { getIsMenusLoading } from 'store/Menus/selectors'
import { getIsLoadingConfigurationModels } from 'store/ConfigurationModels/selectors'
import { getIsItemsLoading } from 'store/Items/selector'
import { getOrgName } from 'store/AppState/selector'

import { getItemKey } from 'utils/getItemKey'

const List = ({ allRevenueCenters }) => {
  const { state: locationState } = useLocation()

  const isModal = !isEmpty(locationState?.revenueCenterUuid)

  const orgName = useSelector(getOrgName)

  const groupedMenusByStandId = useSelector(
    getGroupedMenusForCurrentRevenueCenter
  )

  const isLoadingRevenueCenters = useSelector(
    getIsRevenueCentersLoading
  )
  const isLoadingMenus = useSelector(getIsMenusLoading)
  const isLoadingAvailability = useSelector(getIsLoadingAvailability)
  const isLoadingConfigurationModels = useSelector(
    getIsLoadingConfigurationModels
  )
  // we have to check if items are loading because in Revenue Center Form we can update items which PUT request takes a while
  const isLoadingItems = useSelector(getIsItemsLoading)

  const isLoading =
    (isLoadingRevenueCenters ||
      isLoadingMenus ||
      isLoadingAvailability ||
      isLoadingConfigurationModels ||
      isLoadingItems) &&
    !isModal

  if (isLoading) {
    return <Loader />
  }
  return (
    <>
      <Section className="item-list">
        {allRevenueCenters?.map(({ name, uuid, id, merchantId }) => (
          <Item
            name={name}
            key={getItemKey(uuid, locationState?.updatedResourceUuid)}
            updatedResourceUuid={locationState?.updatedResourceUuid}
            uuid={uuid}
            merchantId={merchantId}
            menus={groupedMenusByStandId?.[id]}
            orgName={orgName}
          />
        ))}
      </Section>
      {isModal && <RevenueCentersDetailsPage />}
    </>
  )
}

export default List
